import { Component, inject } from '@angular/core';
import { ServicesGroupsPageStore } from './services-groups-page.store';
import { ServiceGroupEnum } from '@libs/types/src/services/enum/service-group.enum';
import {
    ServiceSettingServiceGroupComponent,
} from '../../../../../components/common-service/setting/service-setting-service-group/service-setting-service-group.component';

@Component({
    selector: 'app-service-groups-page',
    templateUrl: 'services-groups-page.component.html',
    styleUrls: ['services-groups-page.component.scss'],
    providers: [ServicesGroupsPageStore],
    imports: [
        ServiceSettingServiceGroupComponent,
    ],
})
export class ServicesGroupsPageComponent {

    protected readonly store = inject(ServicesGroupsPageStore);

    protected readonly ServiceGroupEnum = ServiceGroupEnum;

}
